import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/storage';
 
 // Your web app's Firebase configuration
 var firebaseConfig = {
  apiKey: "AIzaSyDqV_Yx0_9SzPjgINzCndYJNUVO9qSOvZE",
  authDomain: "thinkair-task-portal.firebaseapp.com",
  projectId: "thinkair-task-portal",
  storageBucket: "thinkair-task-portal.appspot.com",
  messagingSenderId: "183339509432",
  appId: "1:183339509432:web:42e60c225e959af4b3b64d",
  measurementId: "G-2EFVVSQGYY"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

const db = firebase.firestore(); // access to the database
const auth = firebase.auth(); // access to the auth functions provided by firebase
const storage = firebase.storage(); //access to the database
const currentUser = auth.currentUser; // currently signed in user

export {
    db,
    auth,
    storage,
    currentUser
}